import React from "react";
import WebsiteLogo from "../icons/WebsiteLogo";
import { FacebookIcon, InstagramIcon } from "../icons/SocialIcons";
import { useImages } from "../hooks/useImages";

const GUIDS = {
  logo: '21904a9b-853e-4440-96e2-c149d39d0c52'
}

const Footer: React.FC = () => {
  const logoImage = useImages(GUIDS.logo)?.image;

  return (
    <div className="flex flex-col items-center p-4">
      <WebsiteLogo
        src={logoImage ?? ""}
        className="h-20 sm:h-20 md:h-30 lg:h-40 w-auto"
      />
      <div className="font-sans text-sm text-black p-4 text-center">
        <p>
          Email:{" "}
          <a
            href="mailto:1EarthComposting@gmail.com"
            className="text-blue-500 underline"
          >
            1EarthComposting@gmail.com
          </a>
        </p>
      </div>
      <div className="flex items-center gap-4">
        <InstagramIcon
          url="https://www.instagram.com/1earthcomposting/"
          label="Instagram"
          size={30}
          color="#E1306C"
          className="hover:text-pink-600 transition-colors ml-4"
        />

        <FacebookIcon
          url="https://www.facebook.com/1EarthComposting"
          label="Facebook"
          size={30}
          color="#1877F2"
          className="hover:text-blue-600 transition-colors"
        />
      </div>

      <div className="text-center text-sm md:text-base md:text-right py-3">
        Designed and Hosted by{" "}
        <a
          href="https://yourtools.us/"
          className="text-orange-400 underline hover:text-orange-300"
        >
          Your Tools
        </a>
        . All Rights Reserved.
      </div>
    </div>
  );
};

export default Footer;
